import Vue from "vue";

const toAvif = value =>
{
    if (value === null || typeof value === "undefined")
    {
        return "";
    }

    const str = String(value);

    if (!str.length)
    {
        return "";
    }

    return str.endsWith(".avif") ? str : `${str}.avif`;
};

Vue.filter("itemImages", function(images, accessor)
{
    if (!images)
    {
        return [];
    }

    const imageUrls = [];

    let imagesAccessor = "all";

    if (images.variation && images.variation.length)
    {
        imagesAccessor = "variation";
    }

    for (const image in images[imagesAccessor])
    {
        const imageData = images[imagesAccessor][image];

        // Normalize available URLs to AVIF once for downstream usage (SSR + client).
        if (imageData.url)
        {
            imageData.url = toAvif(imageData.url);
        }

        if (imageData.urlPreview)
        {
            imageData.urlPreview = toAvif(imageData.urlPreview);
        }

        const imageUrl = toAvif(imageData[accessor]);
        const alternate = imageData.names ? imageData.names.alternate : null;
        const name = imageData.names ? imageData.names.name : null;

        imageUrls.push({ url: imageUrl, position: imageData.position, alternate, name });
    }

    return imageUrls;
});
